const tool = function() {
    const _tool = {
        consts: {
            CREATER: 1,
            ASSISTANT: 2,
            STUDENT: 3,
            TEAM_TEACHER: 4,
            SUPERVISOR: 5,
        },
        /**
         * Detect the browser is supported or not
         * @param {string} user agent string
         * @returns {boolean}
         */
        isSupportedBrowsers: function(ua) {
            if ( ! ua) return false;
            if (ua.indexOf('AppleWebKit') >= 0 || ua.indexOf('Firefox') >= 0) return true;
            return false;
        },

        /**
         * Format the seconds into mm:ss format string. 
         * the seconds must be a positive number and NOT greater than 99 minutes 59 seconds, that is: 5999
         * @param {number} seconds The second
         * @returns {string} the formatted string
         */
        formatTime: function(seconds) {
            let sec = Math.ceil(seconds);
            if (isNaN(sec) || sec < 0) return '--:--';
            if (sec > 6039) return '99:99';

            let s = Math.ceil(sec % 60);
            let m = Math.ceil((sec - s) / 60);
            if (s < 10) s = '0' + s;
            if (m < 10) m = '0' + m;
            return m + ':' + s;
        },

        /**
         * Format time into duration string format
         * @param  {number} seconds the seconds
         * @return {string}         the M'SS" format string
         */
        formatTimeAsDurationString: function(seconds) {
            let sec = Math.ceil(seconds);
            if (isNaN(sec) || sec <= 0) return '-';

            let s = Math.ceil(sec % 60);
            let m = Math.ceil((sec - s) / 60);
            if (m == 0) return s + '"';
            return m + "'" + s + '"';
        },

        /**
         * Get the screenx web application origin.
         * for postMessage call, the targetOrigin argument must be set in Firefox browser
         * @param {string} url the url for get origin from. if not set, the current window url will be used
         * @returns {string} the origin part. e.g. https://yuanyq.mbook.cc:8080 
         */
        getOrigin: function(url) {
            let u = url;
            if ( ! u) u = window.location.href;
            let pos = u.indexOf('/', 8);
            if (pos === -1) {
                pos = u.indexOf('?', 8);
            }
            if (pos === -1) return u;
            return u.substring(0, pos);
        },

        /**
         * Replace all of the \n chars to <br> tags
         * @param {string} s the string to be replaced
         * @return {string} the replaced text
         */
        nl2br: function(s) {
            if ( ! s || s.length === 0) return s;
            return s.replace(/\n/g, '<br>');
        },

        /**
         * convert the string to html-safe string
         * if some DOM element need set the html content directly according to the user inputs
         * must convert the string content to save string.
         * @param {string} s the string content
         * @return {string} html-save string content
         */
        htmlspecialchars: function(s) {
            if ( ! s || s.length === 0) return s;
            var map = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#039;',
                '\n': '<br>'
            };
            return s.replace(/[&<>"'\n]/g, function(m) { return map[m];});
        },

        /**
         * Get code language by extension name
         * @param  {string} extName the file extension name
         * @return {string}         the language class for Prism. if can not detect, return null
         */
        getCodeLang: function(extName) {
            if (! extName) return null;
            extName = extName.replace('.', '');
            extName = extName.toLowerCase();
            const langMap = {
                'as': 'actionscript',
                'sh': 'shell',
                'bsh': 'bash',
                'c': 'c',
                'css': 'css',
                'h': 'c',
                'cpp': 'cpp', 
                'hpp': 'cpp',
                'coffee': 'coffeescript',
                'clj': 'clojure',
                'erl': 'erlang',
                'go': 'go',
                'groovy': 'groovy',
                'hs': 'haskell',
                'html': 'html',
                'htm': 'html',
                'svg': 'svg',
                'mathml': 'mathml',
                'mml': 'mathml',
                'ini': 'ini',
                'java': 'java',
                'js': 'js',
                'json': 'json',
                'tex': 'latex',
                'less': 'less',
                'lisp': 'lisp',
                'lua': 'lua',
                'md': 'markdown',
                'm': 'objectivec',
                'pascal': 'pascal',
                'pas': 'pascal',
                'perl': 'perl',
                'php': 'php',
                'plsql': 'plsql',
                'properties': 'properties',
                'py': 'python',
                'r': 'r',
                'jsx': 'jsx',
                'tsx': 'tsx',
                'rb': 'ruby',
                'sas': 'sas',
                'sass': 'sass',
                'scss': 'scss',
                'scala': 'scala',
                'sql': 'sql',
                'stylus': 'stylus',
                'swift': 'swift',
                'tcl': 'tcl',
                'yaml': 'yaml',
                'vb': 'basic',
            };

            return (extName in langMap) ? langMap[extName] : null;
        },


        parseDocument() {
            // if ('com' in window && 'wiris' in window.com && 'js' in window.com.wiris && 'JsPluginViewer' in window.com.wiris.js) {
            //     com.wiris.js.JsPluginViewer.parseDocument();
            // }
            if ('MathJax' in window && _tool.isFunction(MathJax.typeset) ) {
                // LaTex 公式
                MathJax.typeset(['.moso-latex']);
            } else {
                let parseLatexTimer = setInterval(() => {
                    if ('MathJax' in window && _tool.isFunction(MathJax.typeset) ) {
                        // LaTex 公式
                        MathJax.typeset(['.moso-latex']);
                        clearInterval(parseLatexTimer);
                    }
                }, 1000)
            }
            window.Prism && window.Prism.highlightAll();
        },
        isFunction(v){
            return typeof v === 'function'
        },
        /**
         * get img style 
         * @param {number} zoom 
         * @param {number} moveX 
         * @param {number} moveY 
         * @param {number} rotate 
         * @return {string}
         */
        getImgStyle(zoom = 1, moveX = 0, moveY = 0, rotate = 0) {
            let style = `scale(${zoom}, ${zoom}) translate(${moveX}px, ${moveY}px) rotate(${rotate}deg)`;
            return style;
        },
    };
    
    return _tool;
};

// module.exports = tool();
export default tool();
